<template>
  <div>
    <Row>
      <Col span="8">
        <Card>
          <p slot="title">物料大类</p>
          <div
            v-for="item of MaterialCategorylist"
            :key="item.ClassificationID"
            :class="item.ClassificationID === MaterialCategoryinfo.ClassificationID?'ActiveMaterialCategory':'MaterialCategory'"
            @click="MaterialCategorySelectHandleClick(item)"
          >
            <List>
              <ListItem>
                <ListItemMeta
                  :avatar="item.IconUrl"
                  title="大类名称"
                  :description="item.Classification"
                />
                <ListItemMeta title="单位" :description="item.unit" />
              </ListItem>
            </List>
          </div>
        </Card>
      </Col>
      <Col span="15" offset="1">
        <Card dis-hover v-if="MaterialCategoryinfo.ClassificationID">
          <p slot="title">物料中类（{{ MaterialCategoryinfo.Classification }}）</p>
          <List>
            <ListItem>
              <Button type="dashed" icon="ios-add" long @click="NewBuildHandleClick">新增</Button>
            </ListItem>
            <ListItem v-for="item of lists" :key="item.AttributesID">
              <ListItemMeta  :description="item.AttributesName" />
              <!-- <ListItemMeta title="单位" :description="item.unit" /> -->
              <template slot="action">
                <li>
                  <Button
                    type="primary"
                    shape="circle"
                    icon="ios-create-outline"
                    @click="EditHandleClick(item)"
                  >编辑</Button>
                </li>
                <li>
                  <span></span>
                  <Dropdown
                    style="margin-left: 20px"
                    @on-click="SelectHandleClick"
                    @on-visible-change="VisibleChangeHandle(item)"
                  >
                    <Button type="primary">
                      更多
                      <Icon type="ios-arrow-down"></Icon>
                    </Button>
                    <DropdownMenu slot="list">
                      <DropdownItem name="上移">上移</DropdownItem>
                      <DropdownItem name="下移">下移</DropdownItem>
                      <DropdownItem name="删除">删除</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </li>
              </template>
            </ListItem>
          </List>
        </Card>
      </Col>
    </Row>
    <span>
      <li style="margin-top:2rem;color:red">中类改动了，整个大类的价格需要重新维护</li>
    </span>
    <Modal
        title="物料中类编辑"
        v-model="ModalShow"
        :loading="isloading"
        @on-ok="SubmitHandleClick('formCustom')"
        :closable="false">
        <Form :model="info" label-position="top" ref="formCustom" :rules="ruleCustom">
           <FormItem label="名称ID">
               <Input v-model="info.AttributesID" disabled></Input>
           </FormItem>
           <FormItem label="中类名称" prop="AttributesName">
               <Input v-model="info.AttributesName"></Input>
           </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>
import { MaterialCategory1, MiddleCategoriesInfo, ChangeMiddleCategories, MiddleCategoriesMove } from '../../../api/Materiel'
export default {
  name: 'MiddleCategories',
  data () {
    const validateAttributesName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写名称'))
      }
      callback()
    }
    return {
      MaterialCategorylist: Array,
      lists: Array,
      info: {
        AttributesID: '',
        AttributesName: ''
      },
      State: 0, // 用户请求操作 2为删除,1为更新，0为新增
      ModalShow: false,
      isloading: true,
      MaterialCategoryinfo: {
        IconUrl: '',
        ClassificationID: '',
        Classification: '',
        unit: ''
      },
      ruleCustom: {
        AttributesName: [{ validator: validateAttributesName, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetMaterialCategoryData()
  },
  methods: {
    //   获取大类数据
    GetMaterialCategoryData () {
      MaterialCategory1().then(res => {
        if (res.IsSuccess) {
          this.MaterialCategorylist = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 大类被选择后
    MaterialCategorySelectHandleClick (item) {
      this.MaterialCategoryinfo = item
      this.GetMiddleCategoriesInfo(item.ClassificationID)
    },
    // 获取中类物料信息
    GetMiddleCategoriesInfo (ClassificationID) {
      MiddleCategoriesInfo(ClassificationID).then(res => {
        if (res.IsSuccess) {
          this.lists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 提交中类信息确定
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isloading = false
          this.ModalShow = false
          // this.$Modal.remove()
          this.OKHandleClick()
        } else {
          this.isloading = true
          setTimeout(() => {
            this.isloading = false
          }, 2000)
          this.$Message.error('Fail!')
        }
      })
    },
    // 更新中类信息
    OKHandleClick () {
      let isfixed = 0
      // 如果大类ID是0,则是固定属性
      if (this.MaterialCategoryinfo.ClassificationID === '0') { isfixed = 1 }
      ChangeMiddleCategories({
        AttributesID: this.info.AttributesID,
        AttributesName: this.info.AttributesName,
        ClassificationID: this.MaterialCategoryinfo.ClassificationID,
        Isfixed: isfixed, // 是否固定
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetMiddleCategoriesInfo(this.MaterialCategoryinfo.ClassificationID)
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击编辑按钮
    EditHandleClick (item) {
      this.info = item
      this.isloading = true
      this.ModalShow = true
      this.State = 1
    },
    // 点击新增触发事件
    NewBuildHandleClick () {
      this.info = {
        AttributesID: '',
        AttributesName: ''
      }
      this.isloading = true
      this.ModalShow = true
      this.State = 0
    },
    // 下拉菜单出现时事件
    VisibleChangeHandle (item) {
      this.info = item
    },
    // 下拉选择时触发
    SelectHandleClick (name) {
      if (name === '删除') {
        this.State = 2
        this.$Modal.confirm({
          title: '删除属性',
          content: '<p>确定删除 "' + this.info.AttributesName + '"这个分类？</p>',
          onOk: () => {
            this.OKHandleClick()
          }
        })
      } else if (name === '上移') {
        MiddleCategoriesMove(this.info.AttributesID, 1).then((res) => {
          if (res.IsSuccess) {
            this.$Message['success']({
              background: true,
              content: '操作成功'
            })
            this.GetMiddleCategoriesInfo(this.MaterialCategoryinfo.ClassificationID)
          } else {
            this.$Message.error(res.Message)
          }
        })
      } else if (name === '下移') {
        MiddleCategoriesMove(this.info.AttributesID, 0).then((res) => {
          if (res.IsSuccess) {
            this.$Message['success']({
              background: true,
              content: '操作成功'
            })
            this.GetMiddleCategoriesInfo(this.MaterialCategoryinfo.ClassificationID)
          } else {
            this.$Message.error(res.Message)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ActiveMaterialCategory ::v-deep .ivu-list-item-meta-title {
  color: #288cf0;
}
.ActiveMaterialCategory ::v-deep .ivu-list-item-meta-description {
  color: #288cf0;
}
.MaterialCategory {
  &:hover {
    background: #f3f3f3;
    cursor: pointer;
  }
}
.ActiveMaterialCategory {
  background: #f0faff;
  color: #288cf0;
  &:hover {
    cursor: pointer;
  }
}
</style>
